module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_07-d1809aa928b4549cadb19fba1402f4fa.png";